export default class FotobookMenu {
  constructor() {
    this.menu = document.getElementById('fotobook-menu')
    if (!this.menu) return

    // Buscar todos los botones con data-target (excluyendo el botón de pago)
    this.buttons = Array.from(this.menu.querySelectorAll('button[data-target]'))
    if (this.buttons.length === 0) return

    this.init()
  }

  init() {
    // Asignar event listeners a los botones
    this.buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        const targetSelector = button.getAttribute('data-target')
        if (targetSelector) {
          this.showSection(targetSelector)
        }
      })
    })

    // Inicializar: mostrar la primera sección si no hay ninguna visible
    this.initializeVisibleSection()
  }

  showSection(targetSelector) {
    const targetSection = document.querySelector(targetSelector)
    if (!targetSection) return

    // Verificar si la sección ya está visible y activa
    const activeButton = this.buttons.find(btn => btn.getAttribute('data-target') === targetSelector)
    if (activeButton && (activeButton.classList.contains('active') || activeButton.classList.contains('btn-active')) && !targetSection.classList.contains('hidden')) {
      // Ya está activa, no hacer nada
      return
    }

    // Ocultar todas las secciones
    this.buttons.forEach(btn => {
      const btnTarget = btn.getAttribute('data-target')
      if (btnTarget) {
        const section = document.querySelector(btnTarget)
        if (section) {
          section.classList.add('hidden')
        }
        // Remover estado activo de todos los botones
        btn.classList.remove('active', 'is-active', 'btn-active')
        btn.setAttribute('aria-expanded', 'false')
      }
    })

    // Mostrar la sección seleccionada
    targetSection.classList.remove('hidden')
    
    // Activar el botón correspondiente
    if (activeButton) {
      activeButton.classList.add('active', 'is-active', 'btn-active')
      activeButton.setAttribute('aria-expanded', 'true')
    }

    // Mostrar/ocultar el menú de covers según la sección activa
    const coverMenu = document.getElementById('cover-menu')
    if (coverMenu) {
      if (targetSelector === '#cover-section') {
        // Mostrar el menú de covers cuando se activa la sección de portadas
        coverMenu.classList.remove('hidden')
      } else if (targetSelector === '#photos-section') {
        // Ocultar el menú de covers cuando se activa la sección de interiores
        coverMenu.classList.add('hidden')
      }
    }
  }

  initializeVisibleSection() {
    // Verificar si hay alguna sección visible
    let hasVisibleSection = false
    let visibleTarget = null
    this.buttons.forEach(btn => {
      const targetSelector = btn.getAttribute('data-target')
      if (targetSelector) {
        const section = document.querySelector(targetSelector)
        if (section && !section.classList.contains('hidden')) {
          hasVisibleSection = true
          visibleTarget = targetSelector
          // Activar el botón correspondiente
          btn.classList.add('active', 'is-active', 'btn-active')
          btn.setAttribute('aria-expanded', 'true')
        }
      }
    })

    // Si no hay ninguna sección visible, mostrar la primera
    if (!hasVisibleSection && this.buttons.length > 0) {
      const firstButton = this.buttons[0]
      const firstTarget = firstButton.getAttribute('data-target')
      if (firstTarget) {
        this.showSection(firstTarget)
      }
    } else if (visibleTarget) {
      // Si hay una sección visible, asegurar que el menú de covers esté en el estado correcto
      const coverMenu = document.getElementById('cover-menu')
      if (coverMenu) {
        if (visibleTarget === '#cover-section') {
          coverMenu.classList.remove('hidden')
        } else if (visibleTarget === '#photos-section') {
          coverMenu.classList.add('hidden')
        }
      }
    }
  }
}

